import { FormState } from "~/types/form";

/** 落地页类型 */
export enum EFormType {
  none = "none",
  /** user注册表单 */
  tt4b_user_form = "tt4b_user_form",
  /** user注册 by TT Oauth */
  tt4b_user_by_tt = "tt4b_user_by_tt",
  /** adv注册表单 */
  adv_form = "adv_form",
  /** adv 表单带出的留资表单 */
  lead_form = "lead_form",
  /** 单独的线索表单 */
  proactive_lead_form = "proactive_lead_form",
}

/** 当前表单 到 新增表单type枚举 的映射 */
export const FormState2FormType: Record<FormState, EFormType> = {
  [FormState.none]: EFormType.none,
  [FormState.register]: EFormType.tt4b_user_form,
  [FormState.createAccount]: EFormType.adv_form,
  [FormState.leaveInfo]: EFormType.lead_form
};

/** 表单提交结果 */
export enum EFormSubmitResult {
  Success = "1",
  Fail = "0"
}

/** 表单验证码相关行为 */
export enum EVerificationCodeAction {
  Send = "Send",
  Pass = "Pass",
  Fail = "Fail"
}

/** 表单提交失败原因 */
export enum EFormFailReason {
  industry_forbidden = "industry_forbidden",
  /** 高峰限制注册 */
  no_quota = "no_quota",
  /** 所选国家/地区 未开放自助 */
  not_open = "not_open",
  /** ip和所选国家不匹配 */
  ip_mismatch = "ip_mismatch"
}

export enum EUserRegisterInputName {
  mobile = "mobile",
  email = "email",
  password = "password",
  repeatPwd = "repeatPwd",
  code = "code",
  user_term = "user_term",
  /** 邮件营销用户勾选 */
  mkt_consent = "mkt_consent"
}

export enum EFormItemLocation {
  email = "email",
  phone = "phone",
  password = "password",
  confirm_password = "confirm_password",
  verication_code = "verication_code",
  promotion_code = "promotion_code",
  user_term = "user_term",
  /** 邮件营销用户勾选 */
  mkt_consent = "mkt_consent",
  country_or_region = "country_or_region",
  industry = "industry",
  business_name = "business_name",
  time_zone = "time_zone",
  currency = "currency",
  advertising_term = "advertising_term",
  email_notice_term = "email_notice_term",
  is_agency = "is_agency",
  budget = "budget",
  website = "website",
  name = "name",
  competitor_platform_used = "competitor_platform_used"
}

/** 上报key 映射到 tea上报内容 */
export const UserRegisterInputName2Location: Record<
  EUserRegisterInputName,
  EFormItemLocation
> = {
  [EUserRegisterInputName.email]: EFormItemLocation.email,
  [EUserRegisterInputName.mobile]: EFormItemLocation.phone,
  [EUserRegisterInputName.password]: EFormItemLocation.password,
  [EUserRegisterInputName.repeatPwd]: EFormItemLocation.confirm_password,
  [EUserRegisterInputName.code]: EFormItemLocation.verication_code,
  [EUserRegisterInputName.user_term]: EFormItemLocation.user_term,
  [EUserRegisterInputName.mkt_consent]: EFormItemLocation.mkt_consent
};

/**
 * 根据事件确定要上报哪个input组件的用户操作
 * 因为是接入注册SDK，很多逻辑都需要看SDK的源码再进行入侵操作
 */
export function getUserRegisterLocationFromEvent(e: Event) {
  // 假设是input元素，通过name属性匹配到则直接返回
  const inputName = (e.target as HTMLInputElement)
    ?.name as EUserRegisterInputName;
  if (inputName && EUserRegisterInputName[inputName]) {
    return UserRegisterInputName2Location[inputName];
  }

  // 再假设是点击事件，看是否是checkbox点击事件
  const isCheckBoxClickEvent = (e.target as HTMLElement)?.className?.includes?.(
    "account-center-agreement-check checked"
  );
  if (!isCheckBoxClickEvent) {
    return;
  }
  const eventPath = (e as any)?.path || (e?.composedPath && e?.composedPath?.()) || [];
  // 是否为邮件营销条款勾选框
  const isMarketingConsent = eventPath.some(
    (i: HTMLElement) =>
      i.className && i.className.includes("account-center-input-mt16")
  );
  return UserRegisterInputName2Location[
    isMarketingConsent
      ? EUserRegisterInputName.mkt_consent
      : EUserRegisterInputName.user_term
  ];
}
